import { useState } from "react";
import MaintenanceHistoryList from "./MaintenanceHistoryList";

type MaintenanceHistoryProps = {
    idNumber: any;
}

export const MaintenanceHistory = ({
    idNumber
}: MaintenanceHistoryProps) => {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full`}>
                <div>
                    <MaintenanceHistoryList
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                        idNumber={idNumber}
                    />
                </div>
            </div>
        </>
    )
}